export default function Cash() {
  return (
    <div
      className="ion-icon-cash"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M0,96v256h512V96H0z M192.508,320H80.129c0-26.582-21.549-48.129-48.129-48.129V192c35.346,0,64-28.653,64-64h96.509
		C172.576,151.455,160,185.767,160,224S172.576,296.545,192.508,320z M298.089,261.248c-2.582,4.182-5.978,7.602-10.189,10.257
		c-4.214,2.655-9.004,4.607-14.375,5.835c-2.812,0.644-5.654,1.119-8.524,1.432V288h-18v-9.43c-2.768-0.357-5.461-0.863-8.072-1.541
		c-5.688-1.475-10.641-3.659-14.851-6.709c-4.214-3.047-7.584-6.803-10.11-11.573C211.548,254.186,210.24,248,210.04,243h19.735
		c0.096,3,0.828,6.532,2.201,9.184c1.473,2.853,3.526,4.883,6.16,6.7c2.572,1.78,5.532,3.082,8.863,3.919v-34.358
		c-2.436-0.601-5.016-1.245-7.758-1.938c-4.846-1.18-8.873-2.729-12.085-4.646c-3.214-1.918-5.766-4.057-7.661-6.417
		c-1.896-2.359-3.238-4.867-4.028-7.522c-0.791-2.656-1.186-5.358-1.186-8.113c0-5.31,1.186-9.905,3.556-13.791
		c2.368-3.883,5.502-7.104,9.398-9.662c3.895-2.556,8.319-4.448,13.27-5.679c2.154-0.534,4.319-0.945,6.494-1.248V160h18v9.499
		c2.46,0.353,4.856,0.838,7.18,1.473c5.215,1.427,9.796,3.563,13.744,6.414c3.95,2.854,7.083,6.364,9.4,10.542
		c2.109,3.811,3.258,8.072,3.445,13.072h-19.866c-0.753-6-3.175-10.326-7.274-12.923c-1.966-1.246-4.186-2.196-6.629-2.887v30.368
		c2.589,0.639,5.15,1.268,7.654,1.878c3.421,0.836,5.87,1.453,7.346,1.844c3.686,1.083,6.897,2.558,9.637,4.425
		c2.737,1.869,5.028,4.008,6.873,6.417c1.841,2.411,3.21,4.992,4.107,7.744c0.893,2.753,1.343,5.51,1.343,8.262
		C301.96,252.027,300.668,257.07,298.089,261.248z M480,271.871c-26,0-48,21.547-48,48.129H319.491
		C339.424,296.545,352,262.233,352,224s-12.576-72.545-32.51-96H416c0,35.347,28.653,64,64,64V271.871z"/>
	<circle cx="96" cy="224" r="32"/>
	<circle cx="416" cy="224" r="32"/>
	<path d="M272.893,235.21c-2.395-0.823-5.029-1.618-7.893-2.389v30.856c1.592-0.23,3.069-0.547,4.416-0.959
		c3.053-0.934,5.529-2.139,7.425-3.613s3.264-3.171,4.107-5.089c0.842-1.917,1.263-3.858,1.263-5.827
		c0-4.031-0.975-7.006-2.921-8.924C277.34,237.349,275.206,235.999,272.893,235.21z"/>
	<path d="M236.004,190.959c-1.318,1.771-1.975,3.982-1.975,6.638c0,3.738,1.236,6.663,3.712,8.776
		c2.377,2.034,5.468,3.583,9.259,4.661v-26.356c-2.18,0.45-4.192,1.135-6.02,2.078C238.979,187.788,237.32,189.189,236.004,190.959z
		"/>
	<rect y="384" width="512" height="32"/>
</g>
</svg>
`,
      }}
    />
  )
}
